<template>
  <div
    class="modal-level-two-container"
    v-if="forceReload"
    style="z-index: 99999999"
  >
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div class="modal-dialog-level-two">
      <div class="modal-content-level-two">
        <div class="btn-modal-close cursor-pointer" @click="closeModal()">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="modal-header">
          <h4 class="modal-title">IUJP</h4>
        </div>
        <div class="modal-filter-search">
          <InputIcons
            :inputClass="'border-input-red'"
            :placeholder="'Cari Sub Bidang ...'"
            v-model="subSearch"
          />
        </div>
        <div class="modal-body-level-two" v-if="iujpData">
          <div class="modal-content-list">
            <div class="column5"></div>
            <div class="column10">Jenis</div>
            <div class="column30 mr10">Bidang</div>
            <div class="column50 mr10">Sub Bidang</div>
          </div>
          <div
            class="modal-content-list"
            v-for="(item, index) in iujp"
            :key="index"
          >
            <div class="column5">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column10">{{ item.jenis }}</div>
            <div class="column30 mr10">{{ item.bidang }}</div>
            <div class="column50 mr10">{{ item.sub_bidang }}</div>
          </div>
        </div>

        <div class="modal-body-level-two-mobile" v-if="iujpData">
          <div
            class="modal-content-list"
            v-for="(item, index) in iujp"
            :key="index"
          >
            <div class="column5 mr10">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column90">
              <div class="w-full text-gray">Jenis</div>
              <div class="w-full">{{ item.jenis }}</div>
              <div class="w-full text-gray">Bidang</div>
              <div class="w-full">{{ item.bidang }}</div>
              <div class="w-full text-gray">Sub Bidang</div>
              <div class="w-full">{{ item.sub_bidang }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer flex-space-between">
          <button type="button" class="btn btn__red" @click="add()">
            Done
          </button>
          <div class="btn btn__default">
            <BtnIcons
              :className="'level1-section-filter__footer-relative'"
              :path="'icon-refresh.png'"
              :title="'Reset'"
              :position="true"
              :colors="true"
              :onClick="onReset"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    InputIcons: () => import('@/components/Atoms/InputIcons'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
  },
  data() {
    return {
      iujp: [],
      choosedIujp: [],
      subData: [],
      subSearch: '',
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function() {
        return this.$store.state.searchStore.choosedIujp
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedIujp',
          value: newValue,
        })
      },
    },
    iujpData: async function() {
      return this.setUpData()
    },
  },
  watch: {
    subSearch: function(newValue, oldValue) {
      this.searchRun()
    },
  },
  methods: {
    async onReset() {
      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedIujp',
        value: [],
      })
    },
    async add() {
      console.log('subsearch done: ', this.subSearch)
      console.log('add Iujp', this.$store.state.searchStore.choosedIujp)
      await this.closeModal()
    },
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (
          list[i].sub_bidang.toLowerCase().indexOf(search.toLowerCase()) != -1
        ) {
          filteredList.push(list[i])
        }
      }

      this.iujp = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.iujp = this.subData
    },
    async setUpData() {
      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: true,
      })
      const getIujp = await this.$getIujp()
      const defaultIujp = await this.$store.state.level1.choosedIujp
      console.log('default iujp: ', defaultIujp)

      let reduceIujp = await getIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let reduceDefault =
        (await defaultIujp) &&
        defaultIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceIujp, ...reduceDefault }

      let newData = await Object.values(combine)

      this.iujp = await newData.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newData.sort((a, b) => this.$sortAsc(a, b))
      console.log('choosedIujp setup: ', this.choosedIujp)
      this.choosedIujp = await defaultIujp.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: false,
      })
    },
    closeModal() {
      this.$store.commit('modalStore/closeModal', {
        name: 'iujp',
      })
    },
  },
}
</script>
